import iconColor from 'components/iconColor'
import Toast from 'components/Legacy/Toast'
import { NotificationTitleType, NotificationType } from 'data/App/types'
import messages from 'lang'
import isNil from 'lodash/isNil'
import React from 'react'
import { injectIntl, MessageDescriptor, WrappedComponentProps } from 'react-intl'
import styled from 'styled-components'

const Wrapper = styled(Toast)`
  svg {
    box-sizing: content-box;

    &:last-child {
      ${iconColor('dark900')};
    }
  }

  > div:last-child {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  > div:nth-child(2) > div:last-child:empty {
    padding-top: 0;
  }
`

const getTitle = (title: NotificationTitleType): MessageDescriptor =>
  messages[title.toLocaleLowerCase()] || messages.ko_generic

type PropsType = {
  readonly content: NotificationType
  readonly onClose: (type: NotificationType) => void
} & WrappedComponentProps

class Notification extends React.Component<PropsType> {
  handleClose = () => {
    this.props.onClose(this.props.content)
  }

  render() {
    const { content, intl } = this.props
    const title = intl.formatMessage(getTitle(content.title))
    const descMessage = !isNil(content.description)
      ? messages[content.description.toLocaleLowerCase()]
      : content.description
    const descValueMessage = !isNil(content.descValue) ? { value: content.descValue } : {}
    const description = !isNil(descMessage)
      ? intl.formatMessage(descMessage, descValueMessage)
      : content.description

    return (
      <Wrapper
        description={description || ''}
        subtext={content.subtext}
        e2e='notification'
        onClose={this.handleClose}
        title={title}
        type={content.type}
      />
    )
  }
}

export default injectIntl(Notification)
